// Display-only emptiness checks for scorecard tiles. A tile with nothing to
// show is hidden instead of rendering "—" placeholders.

const toNum = (v) => {
  if (v == null || v === '') return null;
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(n) ? n : null;
};

/** True when `row` has at least one finite number among `keys`. */
export const hasAnyNumber = (row, keys) =>
  !!row && keys.some((k) => toNum(row[k]) != null);

// Delta and gap tiles are keyed on their headline number: with a null headline
// the tile would show a "—" hero and only secondary captions.
export const FOB_DELTA_KEYS = ['delta_pct'];
export const FOB_RANGE_KEYS = ['high_value', 'low_value'];
export const TERM_HIGHEST_KEYS = ['value'];
export const TERM_DELTA_KEYS = ['delta_pct'];
export const TERM_GAP_KEYS = ['gap_pct'];

/**
 * What a delta tile shows as its headline: its % when the row has one, else a
 * neutral price when the row has a usable price, else null (tile hidden).
 * Independent of how the row was selected.
 */
export const headlineKind = (row, pctKeys, priceKeys) => {
  if (hasAnyNumber(row, pctKeys)) return 'pct';
  return hasAnyNumber(row, priceKeys) ? 'price' : null;
};
